import { render, staticRenderFns } from "./EditSocialIconsTabLinks.vue?vue&type=template&id=309efa5a&scoped=true&"
import script from "./EditSocialIconsTabLinks.vue?vue&type=script&lang=js&"
export * from "./EditSocialIconsTabLinks.vue?vue&type=script&lang=js&"
import style0 from "./EditSocialIconsTabLinks.vue?vue&type=style&index=0&id=309efa5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309efa5a",
  null
  
)

export default component.exports